export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/X3ruAocUU5GQ8AuF8",
  address: "68 Walton Rd, Molesey, East Molesey KT8 0DL",
  ggMapIframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2489.197950501369!2d-0.3534225999999999!3d51.3994174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760b3d306498b9%3A0x71aec6b66ffadfa9!2sT%20NAIL%20SPA!5e0!3m2!1sen!2s!4v1757087587755!5m2!1sen!2s",
  email: "tnailspa68@gmail.com",
  tel: "+442036092690",
  phone: "+44 203 609 2690",
  facebookId:"102973488300693",
  instagramName: "tnailspa86",
  name: "T Nail Spa",
  bookingUrl: "https://tnailspa.setmore.com",
  openingTime:{
    openTime:{weekdays: "MONDAY - SATURDAY", time:"09:30AM - 06:30PM"},
    closeTime:{weekdays: "SUNDAY & BANK HOLIDAY", time:"CLOSED"}
  },
};
NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    "name": "Maddy Shaw",
    "feedback": "â€œRecently moved to East Molesey and decided to find a closer nail salon than my usual. T Nail Spa is just down the road from me and looked very inviting. I am so glad I made the choice and have fallen in love. The quality of their products is amazing and the staff are all so lovely and talented. The shop is cosy and bright, and doesn't have the usual suffocating smell of chemicals that many nail shops seem to. I would recommend to everyone as such a wonderful place to get your nails done.â€",
    "avatar": "https://i.imgur.com/sU1i6Sk.png"
  },
  {
    "name": "Alice",
    "feedback": "â€œI only ever come here for my shellac toes. Huge selection of colours and usually walk in appointments available no problem. Really good price at Â£22 including take off / shape / file. The polish always lasts me well over two months as well! Theyâ€™re not chatty but I donâ€™t mind that. I would recommend!â€",
    "avatar": "https://i.imgur.com/RsFFmiS.png"
  },
  {
    "name": "Chloe Einchcomb",
    "feedback": "â€œThey saw me last minute this evening as a walk in and got my nails done very quickly, love the colourâ€",
    "avatar": "https://i.imgur.com/KxhUFKM.jpg"
  },
  {
    "name": "Jenny Dao",
    "feedback": "â€œGreat customer service and very talented nail techs. Iâ€™ve been a regular for months and itâ€™s always a positive experience. Highly recommend this salon to anyone looking for quality.â€",
    "avatar": "https://i.imgur.com/Lq7YQ1o.png"
  },
  {
    "name": "Grace Mitchell",
    "feedback": "â€œVery please with my acrylic full set, lasted me a whole month! ðŸ˜Šâ€",
    "avatar": "https://i.imgur.com/HDBW1Xg.png"
  },
  {
    "name": "Emily Carter",
    "feedback": "â€œSuch a friendly and relaxing place. Iâ€™ve been to a lot of salons but this one stands out because of how much care they put into their work. My nails always look beautiful.â€",
    "avatar": "https://i.imgur.com/Ds2X7zK.png"
  },
  {
    "name": "Lily Bennett",
    "feedback": "â€œThe team here is amazing. Theyâ€™re professional, kind, and always make sure youâ€™re comfortable. The salon is spotless and I love how my nails turn out every time.â€",
    "avatar": "https://i.imgur.com/kI3rsKc.jpg"
  },
  {
    "name": "Chloe Anderson",
    "feedback": "â€œBeautiful salon with a relaxing vibe. The staff are so attentive and skilled, and I always leave feeling pampered. Great value for the quality of service you get.â€",
    "avatar": "https://i.imgur.com/92gXkP8.jpg"
  }
]

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
